import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApiError } from '../../../../core';
import { ITableSettings } from '../../../../domains/shared/components/table/interfaces/table-settings.interface';
import { ToastService } from '../../../../domains/shared/components/toast/services/toast.service';
import { UsuarioLogApi } from '../../apis/usuario-log.api';
import { IUsuarioLogSituacao, IUsuarioLogSituacaoResponse } from '../../interfaces/usuario-log-situacao.interface';

// TODO: SUBISTITUIR ESTA INTERFACE POR INTERFACE DO PRÓPRIO COMPONENT DA TABLE
interface IHeader {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: 'asc' | 'desc';
}

@Component({
  selector: 'sgt-log-situacao-table',
  templateUrl: './log-situacao-table.component.html',
  styleUrls: ['./log-situacao-table.component.scss'],
})
export class LogSituacaoTableComponent implements OnChanges {
  @Input() idUsuario: number;

  // Pagination
  page = 1;
  pageSize = 20;

  // Data
  logs: IUsuarioLogSituacao[] = [];
  totalItens = 0;

  // Table
  tableSettings: ITableSettings = {
    loading: false,
    isEmpty: false,
    showFooter: false,
    customTableClass: 'table table-striped table-hover',
    emptyMessage: 'Nenhum registro encontrado',
    totalItens: 0,
    itensPerPage: 20,
  };

  // Table Headers
  headers: IHeader[] = [
    {
      key: 'createdAt',
      label: 'Data',
      sortable: false,
      sortDirection: 'asc',
    },
    {
      key: 'nomeUsuarioCreated',
      label: 'Responsável',
      sortable: false,
      sortDirection: 'asc',
    },
    {
      key: 'situacao',
      label: 'Situação',
      sortable: false,
      sortDirection: 'asc',
    },
    {
      key: 'observacao',
      label: 'Observação',
      sortable: false,
      sortDirection: 'asc',
    }
  ];

  constructor(private toastService: ToastService,
              private usuarioLogApi: UsuarioLogApi) { }


  ngOnChanges(changes: SimpleChanges) {
      for (const propName in changes) {
        // Ao mudar o usuário, recarrega os logs
        if (propName === 'idUsuario') {
            this.page = 1;
            this.fetchSituacoes();
          }
      }
  }

  /** Ao realizar o scroll até o final da tabela, carrega mais registros */
  onScrollBottom() {
    // Verifica se já carregou todos os itens
    if (this.logs.length >= this.tableSettings.totalItens) {
      return;
    }

    this.page += 1;
    this.fetchSituacoes(true);
  }

  /** Pesquisa os registros de logs de situação do usuário */
  private fetchSituacoes(isContentAppend: boolean = false) {
    this.usuarioLogApi.fetchSituacoes(this.idUsuario, this.page, this.pageSize).subscribe({
      next: (response: IUsuarioLogSituacaoResponse) => {
        const res = response;
        if (isContentAppend) {
          this.logs = [...this.logs, ...res.data];
        } else {
          this.logs = res.data;
        }

        this.tableSettings.totalItens = response.totalItens;
      },
      error: (error: ApiError) => {
        this.toastService.error(error.message || 'Erro ao pesquisar os registros de logs de situação do usuário.', {
          title: error.cause || 'Aconteceu algo inesperado.',
          duration: 5000,
        });
        console.error('Erro ao pesquisar os registros de logs de situação do usuário:', error);
      },
      complete: () => {
        this.setPaginationSettings();
      },
    });
  }

  /** Função de trackBy para otimização da renderização da tabela */
  trackById(_: number, item: IUsuarioLogSituacao): number {
    return item.id;
  }

  /** Define as configurações de paginação da tabela */
  private setPaginationSettings() {
    this.tableSettings.isEmpty = this.logs.length === 0;
    this.tableSettings.itensPerPage = this.logs.length;
  }
}
